import { IOwnedAlbum } from "../data_models/ialbum";
import { AGTranslator } from './ag_translator';
import { IPhoto } from '../data_models/iphoto';

/**
 * Responsible to translate all the User Assets Response Models to the Common model, which clients can understand. 
 * @export
 * @class UATranslator
 * @implements {ITranslator}
 */
export class FacebookIngTranslator {
    
    static getInstance(): FacebookIngTranslator {
      if (!FacebookIngTranslator.instance) {
        FacebookIngTranslator.instance = new FacebookIngTranslator();
      }
      return FacebookIngTranslator.instance;
    }
    private static instance: FacebookIngTranslator;
  
    
    translateOwnedAlbum(entity: any): IOwnedAlbum {
        let coverPhoto = entity.picture.data.url
        const album: IOwnedAlbum = {
            albumId: entity.id,
            url: coverPhoto,
            source: "facebook",
            accountId: 0,
            updateDate: undefined,
            createDate: undefined,      
            dataCenter: "",
            systemTags: [],
            userTags: [{key: "caption", value: entity.name}],
            photoCount: entity.count
        };
        //In all albums api , we wont get firstPhoto information
        
        album.firstAssetId = {
            assetId: entity.cover_photo.id,
            ownerId: "",
            assetSource: "facebook",
            thumbnailEncryption: coverPhoto
        };
      return album;
    }   

    
  translateFacebookPhoto(entity: any,accountId:string): IPhoto {    

    const photo: any = {
        id: entity.id,
        accountId: accountId,
        documentId: entity.documentId,
        dataCenter: "AUS",
        name: "",
        size: 0,
        assetId: entity.id,
        url: entity.picture,
        createDate: entity.dateTaken,
        updateDate: entity.dateTaken,
        dateTaken: entity.dateTaken,
        lrHeight: entity.height || 200,
        lrWidth: entity.width || 200,
        landscape: entity.width >= entity.height ? true :false,
        assetSource: "facebook",
        reportingMediaSource: "facebook"
    }     
    return photo;
  }
  
  translateFacebookClusterPhoto = function (entity: any, accountId: string):IPhoto {  
    var pasConvertedImage = FacebookIngTranslator.getInstance().translateFacebookPhoto(entity,accountId);
    var photo = AGTranslator.getInstance().translatePhoto(pasConvertedImage);
    return photo;
  };
  
  translateAlbumPhotos(response: any): any {
    let alumResponse = {albumPhotos: {entities: response}};
    let albumPhotos = AGTranslator.getInstance().translateOwnedAlbumPhotos(true,alumResponse)
    return albumPhotos;
  }
}